import SegmentCore from './core';

export class SegmentBase extends SegmentCore
{

}

export default SegmentBase
